import { CloseOutlined } from '@ant-design/icons';
import { Form, Input } from 'antd';
import React from 'react';
import styled from 'styled-components';
import BookingV4DateSection from './DateSection';
import BookingV4CustomerSection from './CustomerSection';
import BookingV4StaffServicesSerction from './StaffServiceSection';

const BookingV4UI = ({ onClose }: { onClose: () => void }) => {
  return (
    <Container>
      <Header>
        <span>Aloha Booking</span>
        <button type="button" className="close-x" onClick={onClose}>
          <CloseOutlined />
        </button>
      </Header>
      <Content>
        <BookingV4DateSection />
        <BookingV4CustomerSection />
        <BookingV4StaffServicesSerction />
      </Content>
      <NoteSection>
        <Form.Item noStyle name="note">
          <Input.TextArea className="note-input" placeholder="Please enter note..." />
        </Form.Item>
      </NoteSection>
      <Footer>
        <button type="button" className="btn" onClick={onClose}><span>Close</span></button>
        <button type="submit" className="btn btn-submit"><span>OK</span></button>
      </Footer>
    </Container>
  );
};

export default BookingV4UI;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #f6f7fc;
`;
const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  background: #232f3e;
  span {
    flex: 1;
    color: #fff;
    font-family: Poppins;
    font-size: 24px;
    font-weight: 600;
    line-height: normal;
    text-transform: uppercase;
  }
  .close-x {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    color: #fff;
    font-size: 20px;
    cursor: pointer;
  }
`;

const Content = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px 16px 8px;
`;

const NoteSection = styled.div`
  padding: 8px;
  background: #fff;
  box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.15);
  .note-input {
    min-height: 56px;
    padding: 8px;
    border: 1px solid #86909c;
    border-radius: 4px;
    background: #feff9c;
    resize: none;
    color: #505050;
    font-family: Poppins;
    font-size: 16px;
    font-weight: 500;
    &::placeholder {
      color: #505050;
    }
    &:focus,
    &:hover {
      border-color: #86909c;
      box-shadow: none;
      background: #feff9c;
    }
  }
`;

const Footer = styled.div`
display: flex;
padding: 16px 16px 24px 16px;
align-items: flex-end;
gap: 16px;
align-self: stretch;
background: #fff;
  button {
    display: flex;
    height: 56px;
    padding: 16px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 4px;
    flex: 1 0 0;
    border-radius: 4px;
    background: #E5E6EB;
    box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.40), 0 4px 8px -3px rgba(45, 35, 66, 0.30), 0 -3px 0 0 #D6D6E7 inset;
    span {
      color: #1D2129;
      text-transform: uppercase;
      text-align: center;
      font-size: 20px;
      font-weight: 600;
    }
    &.btn-submit {
      background: #ff8890;
      box-shadow: 0 2px 4px 0 rgba(44, 35, 66, 0.4), 0 4px 8px -3px rgba(45, 35, 66, 0.3), 0 -4px 0 0 #e7646d inset;
      span {
        color: #fff;
      }
    }
  }
`;
